var PaymentSenseRequest = require('./paymentSenseRequest.js');
var PaymentSenseResponse = require('./paymentSenseResponse.js');

module.exports.requestSeed = 1;

module.exports.buildRequest  = function (method)
{
    var request = new PaymentSenseRequest();
    request.jsonrpc = "2.0";
    request.method = method;
    request.id = this.requestSeed;

    this.requestSeed = this.requestSeed + 1;
    return request;
}


module.exports.buildResponse  = function (requestId)
{
    var response = new PaymentSenseResponse();
    response.jsonrpc = "2.0";
    response.id = requestId;
    return response;
}
